<template>
<div class="wlx-site-manager-wrapper-1">
    <div class="add-partner-enterprise-head clearfix">
        <div class="top-page-top fl">
            <span class="sp-top-text">考核站点申请</span>
        </div>
        <div class="fr btn-right">
            <el-form :inline="true" size="small">
                <div class="d-search-form-news">
                    <el-form-item>
                        <el-input v-model="schoolName" placeholder="请输入单位名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" class="el-button-colour" icon="el-icon-search" @click="search">搜索</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
    </div>
    <div>
        <el-table ref="multipleeeeTable" :data="list" tooltip-effect="dark">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column prop="schoolName" label="单位名称"></el-table-column>
            <el-table-column prop="responsibleProvince" label="省份"></el-table-column>
            <el-table-column prop="responsibleCity" label="城市"></el-table-column>
            <el-table-column prop="contactsName" label="联系人姓名"></el-table-column>
            <el-table-column prop="contactsPhone" label="联系人联系方式"></el-table-column>
            <el-table-column prop="IsLecturer" label="是否通过">
                <template slot-scope="scope">
                    <span v-if="scope.row.isPost == 0">审核中</span>
                    <span v-if="scope.row.isPost == 1">通过</span>
                    <span v-if="scope.row.isPost == 2">未通过</span>
                </template>
            </el-table-column>
            <el-table-column prop="dateCreated" label="申请时间" width="160"></el-table-column>
            <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="编辑" placement="bottom">
                        <el-button icon="el-icon-edit" size="mini" type="primary" @click="editTable(scope.row.id)"></el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="news-page-con">
        <el-pagination background @size-change="handleSizeChange" @current-change="onPageChangeHandler" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" v-show="total > 0"></el-pagination>
    </div>
</div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
    data() {
        return {
            list: [],
            total: 0,
            pageSize: 10,
            pageIndex: 1,
            schoolName: "", // 搜索条件
        };
    },
    components: {
        imageUpload,
    },
    props: {
        certificateId: {
            type: String,
            default: ""
        }
    },
    created() {
        this.school = this.$store.state.auth.userName;
        this.getSchoolList(1);
    },
    methods: {
        getSchoolList(page) {
            var that = this;
            this.$http
                .post("/api/XOrg/AssessmentApply/getAssessmentApplyList", {
                    schoolName: this.schoolName,
                    certificateId: this.certificateId,
                    page: page,
                    pageSize: this.pageSize,
                })
                .then((rst) => {
                    if (rst.code == 1) {
                        this.list = rst.list;
                        this.total = rst.pagination.totalCount;
                        this.pageSize = rst.pagination.pageSize;
                        this.pageIndex = rst.pagination.pageIndex;
                    } else {
                        this.$message.warning(rst.msg);
                    }
                });
        },
        onPageChangeHandler(page) {
            this.getSchoolList(page);
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getSchoolList();
        },
        search() {},
        editTable(id) {
            this.$router.push({
                name: "editerExamTable",
                params: {
                    tableId: id,
                },
            });
        },
    },
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper-1 {
    background: #fff;
    padding-bottom: 20px;

    .add-partner-enterprise-head {
        border-bottom: 1px solid #f0f0f0;
        height: 60px;

        .add-banner-btn,
        .delete-banner-btn {
            margin-top: 13px;
        }

        .delete-banner-btn {
            margin-right: 62px;
        }

        .top-page-top {
            border: none;
        }
    }

    .banner-page-con {
        padding: 20px 0;
        text-align: center;
    }

    .el-table thead {
        color: #05243D;
    }

    .btn-right {
        margin-top: 14px;
    }

    .export-button-a {
        color: #fff;
        background: #05243D;
        padding: 8px 15px;
        border-radius: 4px;
        margin: 0 10px;
    }
}
</style>
